<template lang="pug">
  main.careers#main
    .hero
      img.hero-image(:src='hero_image.url', :alt='hero_image.alt')
      .hero-text-wrapper
        prismic-rich-text(:field='title')
        prismic-rich-text(:field='description')
    section
      prismic-rich-text(:field='content')
      br
      prismic-rich-text(:field='subtitle')
      .jobs_wrapper
        .job_posting(v-for="(job, index) in jobs", :key=index )
          .leaf_icon
          .posting_content
            a.job-link(:href="job.job_link.url") {{ job.job_title }}
            p {{ job.job_department }}
          a.button(:href="job.job_link.url") {{ button }}
</template>

<script>
export default {
  name: 'career',
  data () {
    return {
      title: null,
      description: null,
      hero_image: '',
      content: null,
      subtitle: null,
      button: null,
      jobs: null,
      metadata: {
        title: null,
        description: null,
        socialTitle: null,
        socialDescription: null,
        socialImage: null
      }
    }
  },
  metaInfo () {
    return {
      title: this.metadata.title,
      titleTemplate: '%s - Progressive Plant Research',
      meta: [
        { name: 'description', content: this.metadata.description },
        { property: 'og:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
        { property: 'og:description', content: this.metadata.socialDescription },
        { property: 'og:image', content: this.metadata.socialImage },
        { name: 'twitter:title', content: this.metadata.socialTitle, template: '%s - Progressive Plant Research' },
        { name: 'twitter:description', content: this.metadata.socialDescription },
        { name: 'twitter:image', content: this.metadata.socialImage }
      ]
    }
  },
  methods: {
    getContent (uid) {
      this.$prismic.client.getSingle('careers')
        .then((document) => {
          console.log(document.data)
          if (document) {
            this.title = document.data.hero_title
            this.description = document.data.hero_description
            this.hero_image = document.data.hero_image
            this.content = document.data.content
            this.subtitle = document.data.subtitle
            this.button = document.data.button_text
            this.jobs = document.data.jobs
            this.metadata.title = document.data.metadata_title
            this.metadata.description = document.data.metadata_description
            this.metadata.socialTitle = document.data.metadata_social_title
            this.metadata.socialDescription = document.data.metadata_social_description
            this.metadata.socialImage = document.data.metadata_social_image.url
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    }
  },
  created () {
    this.getContent(this.$route.params.uid)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid)
    next()
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/components/hero.styl'

.careers
  section
    .jobs_wrapper
      display grid 
      grid-template-columns 1fr
      grid-gap 20px
      .job_posting
        display grid
        grid-template-columns auto 1fr auto
        grid-gap 20px
        align-items center
        padding 2%
        .leaf_icon 
          grid-column 1
          height 50px
          width 50px
          background-image url("../assets/img/ppr-leaf-_top-leaf-color-fill-inverse.svg")
          background-repeat no-repeat
          background-position center

@media (max-width: 768px)
  .careers
    section
      .jobs-posting
        grid-template-columns 1fr auto
        .leaf_icon
          display none
</style>
